import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"add\"><defs><style></style></defs><path d=\"M217.801 483.573h588.376q18.7 0 18.7 18.699v10.396q0 18.699-18.7 18.699H217.8q-18.699 0-18.699-18.7v-10.395q0-18.7 18.7-18.7z\" /><path d=\"M488.092 801.636V213.281a18.7 18.7 0 0118.699-18.699h10.396a18.7 18.7 0 0118.699 18.7v588.354a18.7 18.7 0 01-18.7 18.7h-10.395a18.7 18.7 0 01-18.7-18.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol